/**
 * SpeciesPainter-Registry (docs/12 §1 Prototyp-Mapping).
 * Fallback: generische Knollen-Form fuer unbekannte Champions.
 */
import type { PaintParams, SpeciesPainter } from './types'
import { rimLight, specular, volumeGradient } from '../draw3d'
import { paintKohlrabi } from './kohlrabi'
import { paintAubergine } from './aubergine'
import { paintKarotte } from './karotte'
import { paintKnoblauch } from './knoblauch'
import { paintOkra } from './okra'
import { paintAnanas } from './ananas'
import { paintRoteBeete } from './rotebeete'
import { paintBrombeere } from './brombeere'
import { paintKuerbis } from './kuerbis'
import { paintPastinake } from './pastinake'
import { paintBirne } from './birne'
import { paintPeperoni } from './peperoni'
import { paintKokosnuss } from './kokosnuss'
import { paintRettich } from './rettich'
import { paintWalnuss } from './walnuss'

const genericPainter: SpeciesPainter = (p: PaintParams) => {
  const { ctx, x, y, r, colors } = p
  ctx.save()
  ctx.lineWidth = Math.max(2, r * 0.12)
  ctx.strokeStyle = colors.outline
  ctx.fillStyle = volumeGradient(ctx, x, y, r, colors.body)
  ctx.beginPath()
  ctx.ellipse(x, y, r * 0.85, r * 0.95, 0, 0, Math.PI * 2)
  ctx.fill()
  ctx.stroke()
  if (p.emotion !== 'dead') {
    rimLight(ctx, x, y, r * 0.85, r * 0.95)
    specular(ctx, x - r * 0.28, y - r * 0.38, r * 0.14)
  }
  ctx.restore()
}

const REGISTRY: Record<string, SpeciesPainter> = {
  ironguard: paintKohlrabi,
  rogue: paintAubergine,
  musketeer: paintKarotte,
  cleric: paintKnoblauch,
  hexmaster: paintOkra,
  // Content-Batch 1 (BATTLE-9/17)
  paladin: paintAnanas,
  mage: paintRoteBeete,
  warlock: paintBrombeere,
  druid: paintKuerbis,
  deathknight: paintPastinake,
  monk: paintBirne,
  demonhunter: paintPeperoni,
  shaman: paintKokosnuss,
  necromancer: paintRettich,
  tinker: paintWalnuss,
}

export function getSpeciesPainter(champ: string): SpeciesPainter {
  return REGISTRY[champ] ?? genericPainter
}
